import React from "react";

import { InfoSmIcon as InfoSm, Typography } from "@packages/ds";

import { IconControl } from "ds/Button";
import Dialog from "ds/Dialog";

import * as S from "./EstimateDialog.style";

interface Props {
  label: string;
  tooltipTitle: string;
  tooltipDescription: string;
  total?: string;
  description?: string;
  analyticId?: string;
}
const EstimateDialog = ({
  label,
  tooltipTitle,
  tooltipDescription,
  total,
  description,
  analyticId
}: Props) => {
  return (
    <S.Row>
      <S.DialogWrapper>
        <Typography.BodyText $color="ebony" weight="bold">
          {label}
        </Typography.BodyText>
        <Dialog
          analyticId={analyticId}
          title={tooltipTitle}
          description={tooltipDescription}
          trigger={
            <IconControl aria-label="info-trigger-analytics">
              <InfoSm />
            </IconControl>
          }
        />
      </S.DialogWrapper>
      {description && (
        <Typography.BodyText style={{ flexGrow: 1 }} $color="slate">
          {description}
        </Typography.BodyText>
      )}
      {total && <Typography.Title tag="h2">{total}</Typography.Title>}
    </S.Row>
  );
};
export default EstimateDialog;
